import { render, staticRenderFns } from "./loginBase.vue?vue&type=template&id=2b6dc995&scoped=true&"
import script from "./loginBase.vue?vue&type=script&lang=js&"
export * from "./loginBase.vue?vue&type=script&lang=js&"
import style0 from "./loginBase.vue?vue&type=style&index=0&id=2b6dc995&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6dc995",
  null
  
)

export default component.exports